import querystring from 'querystring';
import i18n from '@/shared/i18n';
import { getProductTitle, getSEOCategoryDescription, getSEOCategoryTitle } from '@/shared/utils';

export function metaDescription(context = {}) {
  const { label, product, section, subcategory } = context;

  let title = 'TV3 Play';
  let description = ' ';
  let image = 'https://static3.go3.tv/scale/go3/images/AVOD_META.png?dsth=1080&dstw=1920&srcmode=0&srcx=0&srcy=0&quality=85&catalogue=1&srcw=1/1&srch=1/1&type=1';

  if (label) {
    const category = i18n.te(`glossary.${label}`) ? i18n.t(`glossary.${label}`) : label;

    title = getSEOCategoryTitle(label, category, subcategory);
    description = getSEOCategoryDescription(label, category, subcategory);
  }

  if (section) {
    title = section.seoTitle ? section.seoTitle + ' | TV3 Play' : title;
    description = section.seoDescription || description;
  }

  if (product) {
    title = getProductTitle(product, { detailPage: true }) + ' | TV3 Play';
    description = product.lead?.length ? product.lead : product.description;

    if (!description?.length) {
      description = i18n.t('meta.main.description');
    }

    if (product.images && product.images.pc && product.images.pc[0]) {
      image = 'https:' + product.images.pc[0].mainUrl;
    }

    if (product.canonicalUrl) {
      document.querySelector('link[rel="canonical"]').setAttribute('href', product.canonicalUrl);
      document.querySelector('meta[property="og:url"]').setAttribute('content', product.canonicalUrl);
    }
  }

  const { dstw, dsth } = querystring.parse(image.split('?')[1]);

  document.title = title;
  document.querySelector('meta[property="og:title"]').setAttribute('content', title);

  document.querySelector('meta[name="description"]').setAttribute('content', description);
  document.querySelector('meta[property="og:description"]').setAttribute('content', description);

  document.querySelector('meta[property="og:image"]').setAttribute('content', image);
  document.querySelector('meta[property="og:image:width"]').setAttribute('content', dstw);
  document.querySelector('meta[property="og:image:height"]').setAttribute('content', dsth);
}
